import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';

const json = {
  1: {
    unit: 'Unit 10',
    id: 'WB4-V2-U10-P70-E1',
    audio: '',
    video: '',
    component: D1,
    textAlign: 'center',
    padding: 0,
    maxLength: 1,
    titleImage: '',
    exerciseKey: 'img/FriendsPlus/Page70/E1/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page70/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page70/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page70/E1/3.jpg', input: true, answer: "d" },
        { url: 'img/FriendsPlus/Page70/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page70/E1/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page70/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page70/E1/7.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page70/E1/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page70/E1/9.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page70/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page70/E1/11.jpg', input: true, answer: "c" },
        { url: 'img/FriendsPlus/Page70/E1/12.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page70/E1/13.jpg' },
      ],
    ]
  },
  2: {
    unit: 'Unit 10',
    id: 'WB4-V2-U10-P70-E2',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 3,
    titleImage: '',
    exerciseKey: 'img/FriendsPlus/Page70/E2/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page70/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page70/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page70/E2/3.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page70/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page70/E2/5.jpg' },
        { url: 'img/FriendsPlus/Page70/E2/6.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page70/E2/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page70/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page70/E2/9.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page70/E2/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page70/E2/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page70/E2/12.jpg' },
        { url: 'img/FriendsPlus/Page70/E2/13.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page70/E2/14.jpg' },
        { url: 'img/FriendsPlus/Page70/E2/15.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page70/E2/16.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page70/E2/17.jpg' },
        { url: 'img/FriendsPlus/Page70/E2/18.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page70/E2/19.jpg' },
        { url: 'img/FriendsPlus/Page70/E2/20.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page70/E2/21.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page70/E2/22.jpg' },
        { url: 'img/FriendsPlus/Page70/E2/23.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page70/E2/24.jpg' },
        { url: 'img/FriendsPlus/Page70/E2/25.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page70/E2/26.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page70/E2/27.jpg' },

      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page70/E2/27.jpg' },

      ],



    ]
  },




}
export default json;